export default "__VITE_ASSET__8222e125__"